module.exports = __webpack_public_path__ + "css/OceanVolt.8d1cf02e.css";